<template>
  <div class="flex items-center border border-border bg-bg rounded p-5">
    <IconInfo class="text-text-ternary mr-6"/>
    <span class="leading-tight text-2sm text-text">
        {{ $t('infoText') }}
        <router-link :to="{name:'settings-calendar'}"
                     class="text-red hover:text-red-hover underline transition duration-200">
          {{ $t('infoTextSettings') }}</router-link>.
      </span>
  </div>
</template>

<script>
import IconInfo from "@/components/icons/IconInfo";
export default {
  name: "CalendarSettingsInfo",
  components: {IconInfo},
  i18n: {
    messages: {
      en: {
        infoText: 'You can view and edit scheduled operations in',
        infoTextSettings: 'settings'
      },
      ru: {
        infoText: 'Посмотреть и отредактировать запланированные операции Вы можете в',
        infoTextSettings: 'настройках'
      }
    }
  }
}
</script>